import { Logger } from "../utils/Logger";

export enum StreamMediaType {
  Audio = "audio",
  Video = "video",
}

export function validateStreamMediaType(mediaType: StreamMediaType): boolean {
  if (!Object.values(StreamMediaType).includes(mediaType)) {
    Logger.warn(`Received an unsupported StreamMediaType: ${mediaType}`);
    return false;
  }
  return true;
}
